import { Component } from 'react';
import { convertToRaw } from 'draft-js';
import styles from 'forms/containers/SdfaStart/SdfaStart.scss';
import formStyles from 'styles/forms.scss';
import StandardRichTextEditor from 'common/components/RichTextEditor/StandardRichTextEditor';

class RichTextEditor extends Component {
    render() {
        const { input: { value, onChange }, required, label, labelAdditional, autoFocus = false } = this.props;
        const onBlurHandler = editorState => {
            const rawContent = convertToRaw(editorState.getCurrentContent());
            onChange(rawContent);
        };
        const requiredClass = required ? formStyles.required : '';
        return (
            <div className={styles.richTextEditor}  data-cy="RichTextEditor">
                <label className={`${styles.textEditorLabel} ${requiredClass}`} data-cy="RichTextEditor-label">
                    {label}{ labelAdditional && <span data-cy="RichTextEditor-labelAdditional">{labelAdditional}</span>}
                </label>
                <StandardRichTextEditor
                    key="descriptionEditor"
                    content={value}
                    onBlur={onBlurHandler}
                    autoFocus={autoFocus} />
            </div>

        );
    }
}

export default RichTextEditor;
